import React from 'react';

import { useFeatureFlag } from '@betterment/shared-components';
import { useParams } from 'react-router-dom';

import { AddSpouseParticipantErrorPage } from './AddSpouseParticipantErrorPage';
import { ParticipantSelectionStep, ParticipantSelectionStepProps } from './ParticipantSelectionStep';

import { FullPageLoader } from '../FullPageLoader';

interface AddSpouseParticipantProps {
  isSingleUserHousehold: boolean;
  partcipantSelectionProps: ParticipantSelectionStepProps;
}

export const AddSpouseParticipant: React.FC<AddSpouseParticipantProps> = ({
  isSingleUserHousehold,
  partcipantSelectionProps,
}) => {
  const { householdId, goalId } = useParams<{ householdId: string; goalId: string }>();
  const { enabled: isAddSpouseToExistingPlanEnabled, loading: isLoading } = useFeatureFlag({
    splitName: 'retail.b4a_solo_401k_existing_plan_add_spouse_q1_2025_enabled',
    context: 'AddSpouseToExistingSolo401kPlan',
  });

  const shouldAddSpouse = !isSingleUserHousehold && isAddSpouseToExistingPlanEnabled;

  if (isLoading) {
    return <FullPageLoader />;
  }

  return shouldAddSpouse ? (
    // @ts-expect-error TS2322 violates strict null checks
    <ParticipantSelectionStep {...{ ...partcipantSelectionProps, goalId }} />
  ) : (
    // @ts-expect-error TS2322 violates strict null checks
    <AddSpouseParticipantErrorPage householdId={householdId} />
  );
};
